<!-- management officeやoperation officeを元にアイテムを出し分けしたい場合に使用する。 -->

<template>
  <v-autocomplete
    :label="label"
    v-model="selectedItem"
    @blur="emitBlur"
    :items="displayItems"
    :item-title="itemName"
    :item-value="itemName"
    v-bind="{ 'return-object': true }"
    multiple
    :readonly="readonly"
    :error-messages="props.errorMessages"
  />
</template>
<script setup lang="ts">
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import { watch, onMounted, ref } from 'vue';

const props = defineProps<{
  modelValue: any[];
  label: string;
  itemName: string; // 表示する項目名
  items: any[];
  managementOffice?: getManagementOffice | undefined | null;
  operationOffices?: getOperationOffice[] | undefined | null;
  errorMessages?: string[];
  readonly?: boolean;
}>();

const emit = defineEmits(['update:modelValue', 'blur']);

const selectedItem = ref<any[] | undefined | null>(undefined);
const displayItems = ref<any[]>(props.items);

// 初期化
onMounted(() => {
  selectedItem.value = props.modelValue;
  filterItems();
});

// 変更を親コンポーネントに伝える
watch(
  () => selectedItem.value,
  (newValue) => {
    emit('update:modelValue', newValue);
  }
);

// modelValueが変更された時にselectedItemを更新する
watch(
  () => props.modelValue,
  (newValue) => {
    selectedItem.value = newValue;
  }
);

// operationOffice
// managementOffice
// items
// が変更された時にdisplayItemsを更新する
watch(
  () => [props.operationOffices, props.managementOffice, props.items],
  () => {
    filterItems();
  }
);

const filterItems = () => {
  let result = props.items;
  if (props.managementOffice !== undefined && props.managementOffice !== null) {
    result = result.filter(
      (item) =>
        item?.managementOfficeId === props.managementOffice?.id &&
        item?.managementOfficeType === props.managementOffice?.type // management officeのIDは重複する可能性があるので、typeで絞り込む。
    );
  }

  if (
    props.operationOffices !== undefined &&
    props.operationOffices !== null &&
    props.operationOffices.length > 0
  ) {
    result = result.filter((item) =>
      props.operationOffices?.some(
        (office) => office.id === item?.operationOfficeId
      )
    );
  }
  displayItems.value = result;

  // 選択されているitemがdisplayItemsに含まれていない場合は選択を解除する
  if (selectedItem.value !== undefined && selectedItem.value !== null) {
    selectedItem.value = selectedItem.value.filter((item) =>
      result.some((resultItem) => resultItem?.id === item?.id)
    );
  }
};

const emitBlur = () => {
  emit('blur');
};
</script>
